import { Debtor } from 'containers/Smava/PersonalFormPrimary/PersonalForm.interface'
import { Data } from 'interfaces/ApolloResponse.interface'
import isEmployedOrHasMinijob from 'utils/formDependencies/conditions/isEmployedOrHasMinijob'

export const showEmploymentPage = (data: Data) =>
  isEmployedOrHasMinijob(Debtor.PRIMARY)(data) ||
  (data.debtors.count === 2 && isEmployedOrHasMinijob(Debtor.SECONDARY)(data))
